export default "__VITE_ASSET__mG4X4ldQ__"